// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
'use client';
import React from 'react';
import { getAnalyticsMetadataAttribute } from '@cloudscape-design/component-toolkit/internal/analytics-metadata';
import useBaseComponent from '../internal/hooks/use-base-component';
import { applyDisplayName } from '../internal/utils/apply-display-name';
import InternalTokenGroup from './internal';
export default function TokenGroup({ items = [], alignment = 'horizontal', ...props }) {
    const baseComponentProps = useBaseComponent('TokenGroup', {
        props: { alignment, disableOuterPadding: props.disableOuterPadding, limit: props.limit, readOnly: props.readOnly },
    });
    const componentAnalyticsMetadata = {
        name: 'awsui.TokenGroup',
        label: 'invalid',
        properties: {
            itemsCount: `${items.length}`,
        },
    };
    return (React.createElement(InternalTokenGroup, { items: items, alignment: alignment, ...props, ...baseComponentProps, ...getAnalyticsMetadataAttribute({ component: componentAnalyticsMetadata }) }));
}
applyDisplayName(TokenGroup, 'TokenGroup');
//# sourceMappingURL=index.js.map